export default __webpack_public_path__ + "static/media/polar.8111db64.mp4";